import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import { getAllProvincias, getLocalidades } from "../../../api/georef/calls.js"
import InputMask from 'react-input-mask';
import axios from "axios";

import auth from '../../../auth/';
import CanalSelect from "./CanalSelect.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"
import SelectSimple from "../../../components/SelectSimple/SelectSimple.js"


import { Input, Label, FormFeedback } from 'reactstrap';

class Create extends Component {
    IMPACTA_PAIS_OTRO_VALUE = "Otro";
    IMPACTA_PAIS_ARGENTINA_VALUE = "Argentina";

    constructor(props) {
        super(props);
        this.state = {
            prefijo: "",
            numero: "",
            canal_id: null,
            departamentopadre_id: null,
            departamento_id: null,
            empresa_id: null,
            usaVale: false,
            vale: null,
            prefijoabreviatura:"",

            impacta_pais: this.IMPACTA_PAIS_ARGENTINA_VALUE,
            impacta_pais_otro: "",
            impacta_provincia: "",
            impacta_ciudad: "",

            dataProvincias: [],
            dataCiudades: [],
            cacheDataTodasCiudades: [], // son más de 4000 localidades en Argentina, se cachean por eficiencia.

            errorApiGeoref: false,
        };
    }

    cargarDatosGeoref() {
        this.setState({
            errorApiGeoref: false,
        }, () => {
            const todasLasProvincias = "";

            Promise.all([
                getAllProvincias(),
                getLocalidades(todasLasProvincias)
            ])
            .then(([responseProvincias, responseCiudades]) => {
                this.setState({
                    dataProvincias: responseProvincias.provincias,
                    dataCiudades: responseCiudades.localidades,
                    cacheDataTodasCiudades: responseCiudades.localidades,
                });
            })
            .catch((error) => {
                this.setState({
                    errorApiGeoref: true,
                })
            });
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if ( this.state.dataProvincias.length === 0 && this.state.cacheDataTodasCiudades.length === 0 ) {
            // Para que no quede ciclando infinitamente hay que chequear con los estados previos
            if ( this.state.dataProvincias !== prevState.dataProvincias || this.state.cacheDataTodasCiudades !== prevState.cacheDataTodasCiudades) {
                this.cargarDatosGeoref();
            }
        }
    }

    componentDidMount(){
        this.cargarDatosGeoref()
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    resetState() {
        this.setState({
            prefijo: "",
            numero: "",
            canal_id: null,
            departamentopadre_id: null,
            departamento_id: null,
            empresa_id: null,
            usaVale: false,
            vale: null,
            prefijoabreviatura:"",

            impacta_pais: this.IMPACTA_PAIS_ARGENTINA_VALUE,
            impacta_pais_otro: "",
            impacta_provincia: "",
            impacta_ciudad: "",
            dataCiudades: this.state.cacheDataTodasCiudades,
        })
    }

    handleDepartamentoPadreChange = (data) => {
        if (this.state.departamentopadre_id !== data.pk) {
            this.setState({
                departamentopadre_id: data.pk,
                departamento_id: null,
            })
        }
    }

    onChangeDepartamento(e) {
        var depto = e.pk;
        var newprefijo = e.abreviatura;
        var url = api.proyectos.solicitudes.getnumero + "?prefijo=" + newprefijo;

        axios.get(url, auth.header())
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        numero: response.data.numero,
                    });
                }
            });

        if(this.state.usaVale){
            this.setState({departamento_id: depto, prefijoabreviatura: newprefijo})
        }else{
            this.setState({ prefijo: newprefijo, departamento_id: depto, prefijoabreviatura: newprefijo });
        }
    }

    handleImpactaPaisChange = (pais) => {
        if (pais && this.state.impacta_pais != pais.value) {
            this.setState({
                impacta_pais: pais.value,
                impacta_pais_otro: "",
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        } else if (pais == null) {
            this.setState({
                impacta_pais: "",
                impacta_pais_otro: "",
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        }
    }

    handleImpactaPaisOtro = (e) => {
        this.setState({
            impacta_pais_otro: e.target.value,
        })
    }

    handleImpactaProvinciaChange = (provincia) => {
        if (provincia && this.state.impacta_provincia != provincia.value) {
            const dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades.filter(ciudad => ciudad.provincia_nombre == provincia.value)
            const existeCiudad = dataCiudadesEnProvincia.find(ciudad => ciudad.nombre == this.state.impacta_ciudad);

            this.setState({
                impacta_provincia: provincia.value,
                dataCiudades: dataCiudadesEnProvincia,
                impacta_ciudad: existeCiudad ? this.state.impacta_ciudad : "",
            })
        } else if (provincia == null) { // En caso de que se limpió el select
            this.setState({
                impacta_provincia: "",
                impacta_ciudad: "",
                dataCiudades: this.state.cacheDataTodasCiudades,
            })
        }
    }

    handleImpactaCiudadChange = (ciudad) => {
        if (ciudad && this.state.impacta_ciudad != ciudad.value) {
            this.setState({
                impacta_ciudad: ciudad.value,
            }, () => {
                if (this.state.impacta_provincia != ciudad.provincia_nombre) {
                    // Caso en que se cambió de ciudad pero no pertenecen a la misma provincia
                    // (solo ocurre si se selecciona una ciudad y no habia provincia seleccionada anteriormente)
                    const dataCiudadesEnProvincia = this.state.cacheDataTodasCiudades.filter(dataCiudad => dataCiudad.provincia_nombre == ciudad.provincia_nombre)

                    this.setState({
                        impacta_provincia: ciudad.provincia_nombre,
                        dataCiudades: dataCiudadesEnProvincia,
                    })
                }
            })
        } else if (ciudad == null) { // En caso de que se limpió el select
            this.setState({
                impacta_ciudad: "",
            })
        }
    }

    render() {
        const {
            impacta_ciudad,
            impacta_pais,
            impacta_pais_otro,
            impacta_provincia,
            dataCiudades,
            dataProvincias,
            errorApiGeoref,
        } = this.state;

        const opcionesImpactaPais = [
            { value: this.IMPACTA_PAIS_OTRO_VALUE, label: "Otro" },
            { value: this.IMPACTA_PAIS_ARGENTINA_VALUE, label: "Argentina" },
        ]

        const opcionesImpactaProvincia = dataProvincias.map(provincia => ({
            value: provincia.nombre,
            label: provincia.nombre,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

        const opcionesImpactaCiudad = dataCiudades.map(ciudad => ({
            value: ciudad.nombre,
            // En caso de que la ciudad tenga mismo nombre pero distinta provincia se aclara (Solo si no hay una provincia seleccionada).
            label: ciudad.nombre + (impacta_provincia === "" ? ` (${ciudad.provincia_nombre})` : ""),
            provincia_nombre: ciudad.provincia_nombre,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

        return (
            <ParadigmaModal
                postUrl={api.proyectos.solicitudes.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"La solicitud ha sido creada con éxito."}
                title={"Nueva Solicitud"}
                buttonTitle={"Nueva Solicitud"}
                buttonIcon={"fa fa-plus fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}

                saveButton={true}
                buttonClass={this.props.buttonClass}
                closeButton={true}
                onClose={() => this.resetState()}
            >

                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Grupo</Label>
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        onChange={this.handleDepartamentoPadreChange}
                                        fieldName=""
                                        url={api.usuarios.grupos.select}
                                        value={this.state.departamentopadre_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Subgrupo</Label>
                                    <ParadigmaAsyncSeeker
                                        disabled={!this.state.departamentopadre_id}
                                        clearable={false}
                                        onChange={(e) => this.onChangeDepartamento(e)}
                                        fieldName={"departamentointerno_id"}
                                        url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                                        value={this.state.departamento_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Número</Label>
                                    <InputMask
                                        name=""
                                        className="form-control"
                                        mask="99999"
                                        value={this.state.numero}
                                        onChange={(event) => this.setState({ numero: event.target.value })}
                                        type="text"
                                    />
                                </div>
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <Input
                                        disabled
                                        style={{ backgroundColor: "#c1c1c1", color: "#4b4b4b"}}
                                        value={this.state.vale ? this.state.prefijo + "-" + this.state.vale : this.state.prefijo + "-" + this.state.numero}
                                    />
                                    <Input
                                        type="hidden"
                                        name="codigo"
                                        value={this.state.vale ? this.state.prefijo + "-" + this.state.vale : this.state.prefijo + "-" + this.state.numero}
                                    />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <p className="ui-section-label">Tipo de solicitud</p>
                                <div className="ui-radio-group">
                                    <input type={"hidden"} name="usaVale" value={this.state.usaVale} />
                                    <Label className={"ui-radio-opt"}>
                                        <input
                                            type={"radio"}
                                            checked={this.state.usaVale == false}
                                            onClick={() => { this.setState({ usaVale: false, prefijo: this.state.prefijoabreviatura, vale: null }) }}
                                        />
                                        <span>Presupuesto</span>
                                    </Label>
                                    <Label className={"ui-radio-opt"}>
                                        <input
                                            type={"radio"}
                                            checked={this.state.usaVale == true}
                                            onClick={() => this.setState({ usaVale: true, prefijo: "V" })}
                                        />
                                        <span>Vale de Innovación</span>
                                    </Label>
                                </div>
                            </div>
                            {this.state.usaVale &&
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Vale de Innovación</Label>
                                        <Input
                                            type="text"
                                            name="vale"
                                            value={this.state.vale}
                                            onChange={(event) => this.setState({ vale: event.target.value })}
                                        />
                                    </div>
                                </div>
                            }
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos principales</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Título</Label>
                                    <Input type="text" name="nombre" />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Forma de Contacto</Label>
                                    <CanalSelect
                                        value={this.state.canal_id}
                                        onChange={(e) => this.setState({ canal_id: e.pk })}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-1"><div className="ui-field">
                                    <Label>Empresa/Organización</Label>
                                    <ParadigmaAsyncSeeker
                                        Create={CreateEmpresas}
                                        fieldName={"empresa_id"}
                                        url={api.clientes.empresas.select}
                                        value={this.state.empresa_id}
                                        onChange={(e) => this.setState({ empresa_id: e.pk })}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Localización donde impacta el proyecto</p>
                            {errorApiGeoref &&
                                <FormFeedback className="d-block">{"Hubo un error con el servidor externo de Georef (puede seguir ingresando manualmente los datos)."}</FormFeedback>
                            }
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>País</Label>
                                    <SelectSimple
                                        name={"impacta_pais"}
                                        options={opcionesImpactaPais}
                                        value={opcionesImpactaPais.find(opcion => opcion.value === impacta_pais)}
                                        onChange={this.handleImpactaPaisChange}
                                    />
                                </div>

                                {impacta_pais === this.IMPACTA_PAIS_OTRO_VALUE &&
                                    <div className="ui-field">
                                        <Label>Otro país</Label>
                                        <Input
                                            type="text"
                                            name={"impacta_pais_otro"}
                                            value={impacta_pais_otro}
                                            onChange={this.handleImpactaPaisOtro}
                                            placeholder="Especifique el país..."
                                        />
                                        <FormFeedback className="col-12"></FormFeedback>
                                    </div>
                                }
                            </div>

                            {impacta_pais != "" && impacta_pais !== this.IMPACTA_PAIS_OTRO_VALUE &&
                                <div className="ui-row-2">
                                    <div className="ui-field">
                                        <Label>Provincia</Label>
                                        {!errorApiGeoref &&
                                            <SelectSimple
                                                name={"impacta_provincia"}
                                                options={opcionesImpactaProvincia}
                                                value={opcionesImpactaProvincia.find(opcion => opcion.value === impacta_provincia)}
                                                onChange={this.handleImpactaProvinciaChange}
                                            />
                                        }
                                        {errorApiGeoref &&
                                            <Fragment>
                                                <Input
                                                    type="text"
                                                    name={"impacta_provincia"}
                                                    value={impacta_provincia}
                                                    onChange={e => this.setState({impacta_provincia: e.target.value})}
                                                    placeholder="Especifique la provincia..."
                                                />
                                                <FormFeedback className="col-12"></FormFeedback>
                                            </Fragment>
                                        }
                                    </div>
                                    <div className="ui-field">
                                        <Label>Ciudad</Label>
                                        {!errorApiGeoref &&
                                            <SelectSimple
                                                name={"impacta_ciudad"}
                                                options={opcionesImpactaCiudad}
                                                value={opcionesImpactaCiudad.find(opcion => opcion.value === impacta_ciudad)}
                                                onChange={this.handleImpactaCiudadChange}
                                            />
                                        }
                                        {errorApiGeoref &&
                                            <Fragment>
                                                <Input
                                                    type="text"
                                                    name={"impacta_ciudad"}
                                                    value={impacta_ciudad}
                                                    onChange={e => this.setState({ impacta_ciudad: e.target.value })}
                                                    placeholder="Especifique la ciudad..."
                                                />
                                                <FormFeedback className="col-12"></FormFeedback>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                            }
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" rows={5} />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Create.js